import { useEffect, useRef } from 'react';
import QRCode from 'qrcode';

/** Renders the deeplink as a QR code client-side (guide §2.3 fallback). */
export default function QrCode({ value, size = 132 }: { value: string; size?: number }) {
  const canvasRef = useRef<HTMLCanvasElement>(null);

  useEffect(() => {
    const canvas = canvasRef.current;
    if (!canvas) return;
    QRCode.toCanvas(canvas, value, { width: size, margin: 1 }).catch(() => {
      // canvas unavailable (jsdom): the textual link stays the source of truth
    });
  }, [value, size]);

  return <canvas ref={canvasRef} width={size} height={size} aria-label={`QR code du lien ${value}`} />;
}
